import { State, Action } from './types/context'

function assertNever(state: State, _: never) {
  return state
}

const DATASET_QUERY_LIMIT = 1000

export function reducer(state: State, action: Action) {
  switch (action.type) {
    case 'setDatasetData': {
      const {
        commitRef = '',
        queryRowCountIsLoading = true,
        queryRowCount = 0,
        datasetRowCount = 0,
        datasetLoading = false,
        updatingFilters = false,
      } = action.payload

      return {
        ...state,
        commitRef,
        queryRowCountIsLoading,
        queryRowCount,
        datasetRowCount,
        datasetLoading,
        updatingFilters,
      }
    }
    case 'setCommitRef': {
      return {
        ...state,
        commitRef: action.payload,
      }
    }
    case 'setDatasetLoading': {
      return {
        ...state,
        datasetLoading: action.payload,
      }
    }
    case 'setUpdatingFilters': {
      return {
        ...state,
        updatingFilters: action.payload,
      }
    }
    case 'resetFilters': {
      return {
        ...state,
        queryOptionsByFieldId: {},
      }
    }
    case 'setQueryOptions': {
      const nextQueryOptionsByFieldsId = {
        ...state.queryOptionsByFieldId,
        ...action.payload,
      }

      return {
        ...state,
        queryOptionsByFieldId: nextQueryOptionsByFieldsId,
      }
    }
    case 'setOffset': {
      return {
        ...state,
        offset: action.payload,
      }
    }
    case 'setShowHiddenColumns': {
      return {
        ...state,
        showHiddenColumns: action.payload,
      }
    }
    case 'setQueryRowCount': {
      return {
        ...state,
        queryRowCount: action.payload,
      }
    }
    default:
      return assertNever(state, action)
  }
}

export const initialState: State = {
  commitRef: '',
  datasetLoading: false,
  datasetRowCount: 0,
  limit: DATASET_QUERY_LIMIT,
  offset: 0,
  showHiddenColumns: false,
  queryOptionsByFieldId: {},
  queryRowCountIsLoading: true,
  queryRowCount: 0,
  updatingFilters: false,
}
